// Upcoming estate sales data — shopper-facing listings.
// UPDATE SALES HERE: add a new object to SALES for each announced sale.
// The first sale in the list is featured as the /upcoming-estate-sales showcase.
// Never publish a client's name or street address on this website.
// Note: the original Easton promotional flyer remains in the media library at
// /images/easton-flyer.png for other marketing use — it is not displayed on this page.

export const SALES = [
  {
    id: "easton-halloween-2026", // internal key — keeps the existing photo gallery and subscriber list linked to this sale
    title: "Easton Flash Sale",
    timeframe: "November 7–8, 2026",
    status: "Flash Sale",
    // Official EstateSales.NET listing for the November 7–8 flash sale.
    estatesalesUrl: "https://www.estatesales.net/MD/Easton/21601/5143044",
    visit: {
      location: "Easton, Maryland",
      dates: "Saturday, November 7 – Sunday, November 8, 2026",
      hoursNote: "Sale hours will be posted with the official listing.",
      policies: "All sales final. Items sold as-is.",
    },
  },
];
